
import React from 'react';
import { TranslationsMap, VoiceType } from './types';

export const IconHome = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
);

export const IconUser = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
);

export const IconMic = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
);

export const IconPlay = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}><path d="M8 5v14l11-7z"/></svg>
);

export const IconPause = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
);

export const IconStar = ({ className = "w-6 h-6", fill = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill={fill} stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
);

export const IconBack = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5m7 7-7-7 7-7"/></svg>
);

export const IconLyrics = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><path d="M8 7h8"/><path d="M8 11h8"/><path d="M8 15h4"/></svg>
);

export const IconDice = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><path d="M7 7h.01M17 7h.01M7 17h.01M17 17h.01M12 12h.01"/></svg>
);

export const IconBook = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
);

export const IconCamera = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>
);

export const IconSettings = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

export const IconLock = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
);

export const IconTrash = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
);

export const IconMagicWand = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 4V2"/><path d="M15 16v-2"/><path d="M8 9h2"/><path d="M20 9h2"/><path d="M17.8 11.8 19 13"/><path d="M15 9h0"/><path d="M17.8 6.2 19 5"/><path d="m3 21 9-9"/><path d="M12.2 6.2 11 5"/>
  </svg>
);

export const VOICES: { id: VoiceType, name: string, descKey: string }[] = [
  { id: 'Kind', name: 'Lilly', descKey: 'voice_kind' },
  { id: 'Mama', name: 'Saphira', descKey: 'voice_mama' },
  { id: 'Papa', name: 'Merlin', descKey: 'voice_papa' },
];

export const LANGUAGES = [
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
  { code: 'ja', label: '日本語', flag: '🇯🇵' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦' },
  { code: 'hi', label: 'हिन्दी', flag: '🇮🇳' },
];

export const TRANSLATIONS: any = {
  de: {
    voice: "Stimme",
    photo: "Foto",
    active: "Aktiv",
    off: "Aus",
    or: "oder",
    voice_kind: "Kind",
    voice_mama: "Mama",
    voice_papa: "Papa",
    welcome: "Willkommen bei Lumi",
    loginEmail: "Anmelden",
    loginTitle: "Anmelden",
    signup: "Neu registrieren",
    onboardingTitle: "Wer bist du?",
    onboardingName: "Dein Name",
    onboardingAge: "Dein Alter",
    startStory: "Traum weben",
    myStories: "Dein Nest",
    credits: "Energie",
    premiumActive: "Premium Aktiv",
    homeGreeting: "was träumen wir heute?",
    homeTitle: "Hallo",
    createTitle: "Dein Traum",
    placeholder: "Was soll passieren? ✨",
    account: "Konto",
    settings: "Einstellungen",
    logout: "Abmelden",
    deleteAccount: "Konto löschen",
    upgrade: "Lumi Plus",
    success: "Gewebt!",
    error: "Fehler beim Weben",
    forgotPass: "Passwort vergessen?",
    weavingStory: "Lumi webt Magie...",
    weavingArt: "Lumi malt Bilder...",
    weavingContinue: "Lumi webt den Traum weiter... ✨",
    continueStory: "Traum weiterspinnen ✨",
    startNow: "Starten ✨",
    firstName: "Vorname",
    email: "E-Mail",
    password: "Passwort",
    profileUpdated: "Profilbild aktualisiert ✨",
    noEnergy: "Lumi braucht eine kleine Mütze voll Schlaf. ✨",
    lockedDream: "Gesperrter Traum",
    energyTitle: "Magische Energie",
    energyDesc: "Deine Gratis-Energie ist leer. Für diesen neuen Zauber benötigt Lumi 0.99€ Energie.",
    payNow: "Jetzt weben (0.99€)",
    payLater: "Später vielleicht",
    language: "Sprache",
    logoutConfirm: "Gute Nacht?",
    logoutDesc: "Möchtest du Lumi für heute verlassen? Deine Träume bleiben sicher in deinem Nest.",
    deleteConfirm: "Warnmeldung",
    deleteDesc: "Bist du sicher? Alle deine gewebten Träume werden für immer gelöscht. Dies kann nicht rückgängig gemacht werden.",
    yesLogout: "Ja, abmelden",
    yesDelete: "Unwiderruflich löschen",
    cancel: "Abbrechen",
    unlimitedMagic: "Unbegrenzte Magie",
    unlimitedDesc: "Keine Limits mehr. Webe unzählige Geschichten, nutze alle Stimmen und behalte alle Träume für immer.",
    priceInfo: "4.99€ / Monat • Jederzeit kündbar",
    connecting: "Lumi verbindet sich mit den Sternen...",
    guardTitle: "Sternen-Wächter",
    guardDesc: "Lumi webt nur freundliche und sichere Träume. Dieser Wunsch passt leider nicht ganz in unsere magische Welt. ✨",
    understood: "Verstanden"
  },
  en: {
    voice: "Voice",
    photo: "Photo",
    active: "Active",
    off: "Off",
    or: "or",
    voice_kind: "Child",
    voice_mama: "Mom",
    voice_papa: "Dad",
    welcome: "Welcome to Lumi",
    loginEmail: "Sign in",
    loginTitle: "Login",
    signup: "Register Now",
    onboardingTitle: "Who are you?",
    onboardingName: "Your Name",
    onboardingAge: "Your Age",
    startStory: "Weave Dream",
    myStories: "Your Nest",
    credits: "Energy",
    premiumActive: "Premium Active",
    homeGreeting: "what are we dreaming today?",
    homeTitle: "Hello",
    createTitle: "Your Dream",
    placeholder: "What happens? ✨",
    account: "Account",
    settings: "Settings",
    logout: "Logout",
    deleteAccount: "Delete Account",
    upgrade: "Lumi Plus",
    success: "Woven!",
    error: "Weaving Error",
    forgotPass: "Forgot password?",
    weavingStory: "Lumi weaves magic...",
    weavingArt: "Lumi paints pictures...",
    weavingContinue: "Lumi continues weaving the dream... ✨",
    continueStory: "Spin the dream further ✨",
    startNow: "Start ✨",
    firstName: "First Name",
    email: "Email",
    password: "Password",
    profileUpdated: "Profile updated ✨",
    noEnergy: "Lumi needs a little nap. ✨",
    lockedDream: "Locked Dream",
    energyTitle: "Magic Energy",
    energyDesc: "Your free energy is empty. Lumi needs 0.99€ energy for this new spell.",
    payNow: "Weave now (0.99€)",
    payLater: "Maybe later",
    language: "Language",
    logoutConfirm: "Good night?",
    logoutDesc: "Would you like to leave Lumi for today? Your dreams stay safe in your nest.",
    deleteConfirm: "Warning",
    deleteDesc: "Are you sure? All your woven dreams will be deleted forever. This cannot be undone.",
    yesLogout: "Yes, logout",
    yesDelete: "Delete permanently",
    cancel: "Cancel",
    unlimitedMagic: "Unlimited Magic",
    unlimitedDesc: "No more limits. Weave countless stories, use all voices, and keep all dreams forever.",
    priceInfo: "4.99€ / Month • Cancel anytime",
    connecting: "Lumi is connecting with the stars...",
    guardTitle: "Star Guardian",
    guardDesc: "Lumi only weaves friendly and safe dreams. This wish doesn't quite fit into our magic world. ✨",
    understood: "Understood"
  },
  fr: {
    voice: "Voix",
    photo: "Photo",
    active: "Activé",
    off: "Désactivé",
    or: "ou",
    voice_kind: "Enfant",
    voice_mama: "Maman",
    voice_papa: "Papa",
    welcome: "Bienvenue chez Lumi",
    loginEmail: "Se connecter",
    loginTitle: "Connexion",
    signup: "S'inscrire",
    onboardingTitle: "Qui es-tu?",
    onboardingName: "Ton nom",
    onboardingAge: "Ton âge",
    startStory: "Tisser un rêve",
    myStories: "Ton nid",
    credits: "Énergie",
    premiumActive: "Premium Actif",
    homeGreeting: "à quoi rêvons-nous aujourd'hui?",
    homeTitle: "Bonjour",
    createTitle: "Ton rêve",
    placeholder: "Que doit-il se passer? ✨",
    account: "Compte",
    settings: "Paramètres",
    logout: "Se déconnecter",
    deleteAccount: "Supprimer le compte",
    upgrade: "Lumi Plus",
    success: "Tissé!",
    error: "Erreur de tissage",
    forgotPass: "Mot de passe oublié?",
    weavingStory: "Lumi tisse de la magie...",
    weavingArt: "Lumi peint des images...",
    weavingContinue: "Lumi continue de tisser le rêve... ✨",
    continueStory: "Continuer le rêve ✨",
    startNow: "Démarrer ✨",
    firstName: "Prénom",
    email: "E-mail",
    password: "Mot de passe",
    profileUpdated: "Profil mis à jour ✨",
    noEnergy: "Lumi a besoin d'une petite sieste. ✨",
    lockedDream: "Rêve verrouillé",
    energyTitle: "Énergie magique",
    energyDesc: "Votre énergie gratuite est épuisée. Lumi a besoin de 0.99€ d'énergie pour ce nouveau sort.",
    payNow: "Tisser maintenant (0.99€)",
    payLater: "Peut-être plus tard",
    language: "Langue",
    logoutConfirm: "Bonne nuit?",
    logoutDesc: "Voulez-vous quitter Lumi pour aujourd'hui? Vos rêves resteront en sécurité dans votre nid.",
    deleteConfirm: "Avertissement",
    deleteDesc: "Êtes-vous sûr? Tous vos rêves tissés seront supprimés pour toujours. C'est irréversible.",
    yesLogout: "Oui, se déconnecter",
    yesDelete: "Supprimer définitivement",
    cancel: "Annuler",
    unlimitedMagic: "Magie illimitée",
    unlimitedDesc: "Plus de limites. Tissez d'innombrables histoires, utilisez toutes les voix et gardez tous vos rêves pour toujours.",
    priceInfo: "4.99€ / Mois • Annulable à tout moment",
    connecting: "Lumi se connecte aux étoiles...",
    guardTitle: "Gardien des étoiles",
    guardDesc: "Lumi ne tisse que des rêves amicaux et sûrs. Ce vœu ne correspond pas tout à fait à notre monde magique. ✨",
    understood: "Compris"
  },
  es: {
    voice: "Voz",
    photo: "Foto",
    active: "Activo",
    off: "Apagado",
    or: "o",
    voice_kind: "Niño",
    voice_mama: "Mamá",
    voice_papa: "Papá",
    welcome: "Bienvenido a Lumi",
    loginEmail: "Iniciar sesión",
    loginTitle: "Iniciar sesión",
    signup: "Registrarse",
    onboardingTitle: "¿Quién eres?",
    onboardingName: "Tu nombre",
    onboardingAge: "Tu edad",
    startStory: "Tejer sueño",
    myStories: "Tu nido",
    credits: "Energía",
    premiumActive: "Premium Activo",
    homeGreeting: "¿qué soñamos hoy?",
    homeTitle: "Hola",
    createTitle: "Tu sueño",
    placeholder: "¿Qué quieres que pase? ✨",
    account: "Cuenta",
    settings: "Ajustes",
    logout: "Cerrar sesión",
    deleteAccount: "Eliminar cuenta",
    upgrade: "Lumi Plus",
    success: "¡Tejido!",
    error: "Error al tejer",
    forgotPass: "¿Olvidaste tu contraseña?",
    weavingStory: "Lumi teje magia...",
    weavingArt: "Lumi pinta cuadros...",
    weavingContinue: "Lumi sigue tejiendo el sueño... ✨",
    continueStory: "Seguir soñando ✨",
    startNow: "Empezar ✨",
    firstName: "Nombre",
    email: "E-mail",
    password: "Contraseña",
    profileUpdated: "Perfil actualizado ✨",
    noEnergy: "Lumi necesita una pequeña siesta. ✨",
    lockedDream: "Sueño bloqueado",
    energyTitle: "Energía mágica",
    energyDesc: "Tu energía gratuita se ha agotado. Lumi necesita 0.99€ de energía para este nuevo hechizo.",
    payNow: "Tejer ahora (0.99€)",
    payLater: "Tal vez después",
    language: "Idioma",
    logoutConfirm: "¿Buenas noches?",
    logoutDesc: "¿Quieres dejar Lumi por hoy? Tus sueños se quedarán seguros en tu nido.",
    deleteConfirm: "Aviso",
    deleteDesc: "¿Estás seguro? Todos tus sueños tejidos se borrarán para siempre. No se puede deshacer.",
    yesLogout: "Sí, cerrar sesión",
    yesDelete: "Eliminar permanentemente",
    cancel: "Cancelar",
    unlimitedMagic: "Magia ilimitada",
    unlimitedDesc: "Sin límites. Teje historias sin fin, usa todas las voces y guarda tus sueños para siempre.",
    priceInfo: "4.99€ / Mes • Cancela cuando quieras",
    connecting: "Lumi se conecta con las estrellas...",
    guardTitle: "Guardián estelar",
    guardDesc: "Lumi solo teje sueños amables y seguros. Este deseo no encaja del todo en nuestro mundo mágico. ✨",
    understood: "Entendido"
  },
  zh: {
    voice: "声音",
    photo: "照片",
    active: "已开启",
    off: "已关闭",
    or: "或者",
    voice_kind: "孩子",
    voice_mama: "妈妈",
    voice_papa: "爸爸",
    welcome: "欢迎来到 Lumi",
    loginEmail: "登录",
    loginTitle: "登录",
    signup: "立即注册",
    onboardingTitle: "你是谁？",
    onboardingName: "你的名字",
    onboardingAge: "你的年龄",
    startStory: "编织梦想",
    myStories: "你的小巢",
    credits: "能量",
    premiumActive: "高级版已激活",
    homeGreeting: "今天我们梦见什么？",
    homeTitle: "你好",
    createTitle: "你的梦想",
    placeholder: "想发生什么？ ✨",
    account: "账户",
    settings: "设置",
    logout: "登出",
    deleteAccount: "删除账户",
    upgrade: "Lumi Plus",
    success: "编织成功！",
    error: "编织错误",
    forgotPass: "忘记密码？",
    weavingStory: "Lumi 正在编织魔法...",
    weavingArt: "Lumi 正在画画...",
    weavingContinue: "Lumi 正在继续编织梦想... ✨",
    continueStory: "继续编织梦想 ✨",
    startNow: "开始 ✨",
    firstName: "名字",
    email: "电子邮箱",
    password: "密码",
    profileUpdated: "个人资料已更新 ✨",
    noEnergy: "Lumi 需要睡一小会儿。 ✨",
    lockedDream: "锁定的梦想",
    energyTitle: "魔法能量",
    energyDesc: "您的免费能量已用完。Lumi 需要 0.99 欧元的能量来施展这个新法术。",
    payNow: "立即编织 (0.99€)",
    payLater: "以后再说",
    language: "语言",
    logoutConfirm: "晚安？",
    logoutDesc: "今天要离开 Lumi 吗？您的梦想将安全地留在您的小巢里。",
    deleteConfirm: "警告",
    deleteDesc: "您确定吗？所有编织的梦想都将被永久删除。此操作无法撤销。",
    yesLogout: "是的，登出",
    yesDelete: "永久删除",
    cancel: "取消",
    unlimitedMagic: "无限魔法",
    unlimitedDesc: "不再受限。编织无数的故事，使用所有的声音，并永久保留所有的梦想。",
    priceInfo: "4.99€ / 月 • 随时取消",
    connecting: "Lumi 正在连接群星...",
    guardTitle: "星辰守护者",
    guardDesc: "Lumi 只编织友好且安全的梦想。这个愿望不太符合我们的魔法世界。 ✨",
    understood: "明白了"
  },
  ja: {
    voice: "声",
    photo: "写真",
    active: "オン",
    off: "オフ",
    or: "または",
    voice_kind: "子供",
    voice_mama: "ママ",
    voice_papa: "パパ",
    welcome: "Lumi へようこそ",
    loginEmail: "ログイン",
    loginTitle: "ログイン",
    signup: "新規登録",
    onboardingTitle: "お名前は？",
    onboardingName: "あなたの名前",
    onboardingAge: "あなたの年齢",
    startStory: "夢を紡ぐ",
    myStories: "あなたの巣",
    credits: "エネルギー",
    premiumActive: "プレミアム有効",
    homeGreeting: "今日はどんな夢を見る？",
    homeTitle: "こんにちは",
    createTitle: "あなたの夢",
    placeholder: "何が起きてほしい？ ✨",
    account: "アカウント",
    settings: "設定",
    logout: "ログアウト",
    deleteAccount: "アカウント削除",
    upgrade: "Lumi Plus",
    success: "紡ぎました！",
    error: "エラーが発生しました",
    forgotPass: "パスワードをお忘れですか？",
    weavingStory: "Lumi が魔法を紡いでいます...",
    weavingArt: "Lumi が絵を描いています...",
    weavingContinue: "Lumi が夢の続きを紡いでいます... ✨",
    continueStory: "夢の続きを見る ✨",
    startNow: "スタート ✨",
    firstName: "名前",
    email: "メールアドレス",
    password: "パスワード",
    profileUpdated: "プロフィールを更新しました ✨",
    noEnergy: "Lumi は少しお休みが必要です。 ✨",
    lockedDream: "ロックされた夢",
    energyTitle: "魔法のエネルギー",
    energyDesc: "無料エネルギーがなくなりました。この新しい魔法には 0.99€ のエネルギーが必要です。",
    payNow: "今すぐ紡ぐ (0.99€)",
    payLater: "また今度",
    language: "言語",
    logoutConfirm: "おやすみなさい？",
    logoutDesc: "今日は Lumi を終了しますか？夢はあなたの巣に安全に保管されます。",
    deleteConfirm: "警告",
    deleteDesc: "本当によろしいですか？紡いだすべての夢が永久に削除されます。この操作は取り消せません。",
    yesLogout: "はい、ログアウトします",
    yesDelete: "永久に削除する",
    cancel: "キャンセル",
    unlimitedMagic: "無限の魔法",
    unlimitedDesc: "もう制限はありません。無数の物語を紡ぎ、すべての声を使用し、すべての夢を永遠に保存できます。",
    priceInfo: "4.99€ / 月 • いつでも解約可能",
    connecting: "Lumi が星々とつながっています...",
    guardTitle: "星の守護者",
    guardDesc: "Lumi は優しく安全な夢だけを紡ぎます。この願いは私たちの魔法の世界には少し合わないようです。 ✨",
    understood: "わかりました"
  },
  it: {
    voice: "Voce",
    photo: "Foto",
    active: "Attivo",
    off: "Disattivo",
    or: "oppure",
    voice_kind: "Bambino",
    voice_mama: "Mamma",
    voice_papa: "Papà",
    welcome: "Benvenuto su Lumi",
    loginEmail: "Accedi",
    loginTitle: "Accedi",
    signup: "Registrati",
    onboardingTitle: "Chi sei?",
    onboardingName: "Il tuo nome",
    onboardingAge: "La tua età",
    startStory: "Tessi sogno",
    myStories: "Il tuo nido",
    credits: "Energia",
    premiumActive: "Premium Attivo",
    homeGreeting: "cosa sogniamo oggi?",
    homeTitle: "Ciao",
    createTitle: "Il tuo sogno",
    placeholder: "Cosa vuoi che succeda? ✨",
    account: "Account",
    settings: "Impostazioni",
    logout: "Disconnetti",
    deleteAccount: "Elimina account",
    upgrade: "Lumi Plus",
    success: "Tessuto!",
    error: "Errore di tessitura",
    forgotPass: "Password dimenticata?",
    weavingStory: "Lumi tesse magia...",
    weavingArt: "Lumi dipinge quadri...",
    weavingContinue: "Lumi continua a tessere il sogno... ✨",
    continueStory: "Continua a sognare ✨",
    startNow: "Inizia ✨",
    firstName: "Nome",
    email: "E-mail",
    password: "Password",
    profileUpdated: "Profilo aggiornato ✨",
    noEnergy: "Lumi ha bisogno di un sonnellino. ✨",
    lockedDream: "Sogno bloccato",
    energyTitle: "Energia magica",
    energyDesc: "La tua energia gratuita è esaurita. Lumi ha bisogno di 0.99€ di energia per questo nuovo incantesimo.",
    payNow: "Tessi ora (0.99€)",
    payLater: "Forse più tardi",
    language: "Lingua",
    logoutConfirm: "Buonanotte?",
    logoutDesc: "Vuoi lasciare Lumi per oggi? I tuoi sogni rimarranno al sicuro nel tuo nido.",
    deleteConfirm: "Avviso",
    deleteDesc: "Sei sicuro? Tutti i tuoi sogni tessuti verranno eliminati per sempre. Non si può tornare indietro.",
    yesLogout: "Sì, disconnetti",
    yesDelete: "Elimina permanentemente",
    cancel: "Annulla",
    unlimitedMagic: "Magia illimitata",
    unlimitedDesc: "Niente più limiti. Tessi infinite storie, usa tutte le voci e conserva i tuoi sogni per sempre.",
    priceInfo: "4.99€ / Mese • Annullabile in qualsiasi momento",
    connecting: "Lumi si connette con le stelle...",
    guardTitle: "Guardiano stellare",
    guardDesc: "Lumi tesse solo sogni amichevoli e sicuri. Questo desiderio non si adatta del tutto al nostro mondo magico. ✨",
    understood: "Capito"
  },
  ar: {
    voice: "الصوت",
    photo: "صورة",
    active: "مفعل",
    off: "معطل",
    or: "أو",
    voice_kind: "طفل",
    voice_mama: "ماما",
    voice_papa: "بابا",
    welcome: "مرحباً بك في لومي",
    loginEmail: "تسجيل الدخول",
    loginTitle: "تسجيل الدخول",
    signup: "تسجيل جديد",
    onboardingTitle: "من أنت؟",
    onboardingName: "اسمك",
    onboardingAge: "عمرك",
    startStory: "نسج حلم",
    myStories: "عشك",
    credits: "طاقة",
    premiumActive: "بريميوم نشط",
    homeGreeting: "ماذا سنحلم اليوم؟",
    homeTitle: "مرحباً",
    createTitle: "حلمك",
    placeholder: "ماذا تريد أن يحدث؟ ✨",
    account: "الحساب",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    deleteAccount: "حذف الحساب",
    upgrade: "لومي بلس",
    success: "تم النسج!",
    error: "خطأ in النسج",
    forgotPass: "نسيت كلمة السر؟",
    weavingStory: "لومي تنسج السحر...",
    weavingArt: "لومي ترسم الصور...",
    weavingContinue: "لومي تواصل نسج الحلم... ✨",
    continueStory: "واصل نسج الحلم ✨",
    startNow: "ابدأ ✨",
    firstName: "الاسم الأول",
    email: "البريد الإلكتروني",
    password: "كلمة السر",
    profileUpdated: "تم تحديث الصورة ✨",
    noEnergy: "لومي تحتاج غفوة قصيرة. ✨",
    lockedDream: "حلم مقفل",
    energyTitle: "طاقة سحرية",
    energyDesc: "نفدت طاقتك المجانية. لومي تحتاج 0.99 يورو طاقة لهذا السحر الجديد.",
    payNow: "انسج الآن (0.99€)",
    payLater: "ربما لاحقاً",
    language: "اللغة",
    logoutConfirm: "تصبح على خير؟",
    logoutDesc: "هل تريد مغادرة لومي لليوم؟ أحلامك ستبقى آمنة في عشك.",
    deleteConfirm: "تحذير",
    deleteDesc: "هل أنت متأكد؟ سيتم حذف جميع أحلامك المنسوجة للأبد. لا يمكن التراجع عن هذا.",
    yesLogout: "نعم، خروج",
    yesDelete: "حذف نهائي",
    cancel: "إلغاء",
    unlimitedMagic: "سحر غير محدود",
    unlimitedDesc: "لا حدود بعد الآن. انسج قصصاً لا حصر لها، استخدم جميع الأصوات، واحتفظ بكل أحلامك للأبد.",
    priceInfo: "4.99€ / شهر • إلغاء في أي وقت",
    connecting: "لومي تتصل بالنجوم...",
    guardTitle: "حارس النجوم",
    guardDesc: "لومي تنسج الأحلام اللطيفة والآمنة فقط. هذه الأمنية لا تناسب عالمنا السحري تماماً. ✨",
    understood: "فهمت"
  },
  hi: {
    voice: "आवाज़",
    photo: "फ़ोटो",
    active: "चालू",
    off: "बंद",
    or: "या",
    voice_kind: "बच्चा",
    voice_mama: "माँ",
    voice_papa: "पापा",
    welcome: "Lumi में आपका स्वागत है",
    loginEmail: "लॉग इन करें",
    loginTitle: "लॉग इन",
    signup: "नया खाता बनाएँ",
    onboardingTitle: "आप कौन हैं?",
    onboardingName: "आपका नाम",
    onboardingAge: "आपकी उम्र",
    startStory: "सपना बुनें",
    myStories: "आपका घोंसला",
    credits: "ऊर्जा",
    premiumActive: "प्रीमियम सक्रिय",
    homeGreeting: "आज हम कौन-सा सपना देखें?",
    homeTitle: "नमस्ते",
    createTitle: "आपका सपना",
    placeholder: "क्या होना चाहिए? ✨",
    account: "खाता",
    settings: "सेटिंग्स",
    logout: "लॉग आउट",
    deleteAccount: "खाता हटाएँ",
    upgrade: "Lumi Plus",
    success: "बुन दिया गया!",
    error: "सपना बुनने में समस्या",
    forgotPass: "पासवर्ड भूल गए?",
    weavingStory: "Lumi जादू बुन रही है...",
    weavingArt: "Lumi चित्र बना रही है...",
    weavingContinue: "Lumi सपने को आगे बुन रही है... ✨",
    continueStory: "सपने को आगे बुनें ✨",
    startNow: "शुरू करें ✨",
    firstName: "नाम",
    email: "ईमेल",
    password: "पासवर्ड",
    profileUpdated: "प्रोफ़ाइल चित्र बदल दिया गया ✨",
    noEnergy: "Lumi को थोड़ी-सी नींद चाहिए। ✨",
    lockedDream: "बंद सपना",
    energyTitle: "जादुई ऊर्जा",
    energyDesc: "आपकी निःशुल्क ऊर्जा समाप्त हो गई है। इस नए जादू के लिए Lumi को 0.99€ ऊर्जा चाहिए।",
    payNow: "अभी बुनें (0.99€)",
    payLater: "शायद बाद में",
    language: "भाषा",
    logoutConfirm: "शुभ रात्रि?",
    logoutDesc: "क्या आप आज के लिए Lumi से बाहर जाना चाहते हैं? आपके सपने घोंसले में सुरक्षित रहेंगे।",
    deleteConfirm: "चेतावनी",
    deleteDesc: "क्या आप निश्चित हैं? आपके सभी बुने हुए सपने हमेशा के लिए हट जाएँगे। इसे वापस नहीं किया जा सकता।",
    yesLogout: "हाँ, लॉग आउट",
    yesDelete: "हमेशा के लिए हटाएँ",
    cancel: "रद्द करें",
    unlimitedMagic: "असीम जादू",
    unlimitedDesc: "अब कोई सीमा नहीं। अनगिनत कहानियाँ बुनें, सभी आवाज़ें चुनें और अपने सपने हमेशा सहेज कर रखें।",
    priceInfo: "4.99€ / महीना • कभी भी रद्द करें",
    connecting: "Lumi सितारों से जुड़ रही है...",
    guardTitle: "तारों का रक्षक",
    guardDesc: "Lumi केवल दयालु और सुरक्षित सपने बुनती है। यह इच्छा हमारी जादुई दुनिया में पूरी तरह नहीं बैठती। ✨",
    understood: "समझ गया"
  }
};

export const COZY_SLEEPING_MOON = (
  <svg viewBox="0 0 200 200" className="w-full h-full filter drop-shadow-[0_0_50px_rgba(255,255,255,0.95)] animate-float-moon">
    <circle cx="100" cy="100" r="95" fill="#ffffff" fillOpacity="0.4" className="animate-pulse" />
    <path d="M 130 60 A 60 60 0 1 0 130 140 A 54 54 0 1 1 130 60" fill="#fde68a" />
    <g className="moon-eye">
        <path d="M 70 105 Q 85 112 100 105" fill="none" stroke="#1e293b" strokeWidth="4" strokeLinecap="round" />
        <path d="M 105 95 Q 120 102 135 95" fill="none" stroke="#1e293b" strokeWidth="4" strokeLinecap="round" />
    </g>
    <circle cx="80" cy="122" r="10" fill="#fca5a5" fillOpacity="0.8" />
    <circle cx="125" cy="112" r="10" fill="#fca5a5" fillOpacity="0.8" />
  </svg>
);
